import React from 'react'
import {useTranslation} from 'react-i18next'
import {toast} from 'react-toastify'

import {ToastMessage} from '~/react/components/Toast'

import {useRails} from '~/react/contexts/rails'
import {requestVerification} from '~/api'
import {IdentificationBadgeIcon} from '~/react/icons/IdentificationBadgeIcon'

export const stepName = 'idVerification'

const calculateStatus = ({verificationStatus}) => {
  if (verificationStatus === 'verified') {
    return 'completed'
  }
  if (verificationStatus === 'pending') {
    return 'reviewing'
  }

  return 'incomplete'
}

export const useIdVerificationStep = (stepperData) => {
  const {t} = useTranslation('points')
  const i18nPrefix = 'points:dashboardScreen.onboardingStepper.steps.kycVerify'
  const {
    organisation: {
      currentSupplier: {id: supplierId},
    },
    authenticityToken,
  } = useRails()
  const [requested, setRequested] = React.useState(false)

  const handleVerifyClick = () => {
    setRequested(true)

    requestVerification({authenticityToken, supplierId})
      .then(() => {
        toast.dark(
          <ToastMessage>
            FirstAML has sent you an email to start the KYC process.
          </ToastMessage>,
        )
      })
      .catch(() => {
        toast.error(
          <ToastMessage>
            Something went wrong. Please try again or contact support.
          </ToastMessage>,
        )
      })
  }

  const verificationStatus =
    stepperData.kycStatus !== 'verified' && requested
      ? 'pending'
      : stepperData.kycStatus

  return {
    name: stepName,
    visible: true,
    status: calculateStatus({verificationStatus}),
    icon: <IdentificationBadgeIcon />,
    title: t(`${i18nPrefix}.title`),
    subtitle: {
      default: t(`${i18nPrefix}.subtitle.incomplete`),
      reviewing: t(`${i18nPrefix}.subtitle.reviewing`),
      completed: t(`${i18nPrefix}.subtitle.completed`),
    },
    action: {
      label: t(`${i18nPrefix}.actionLabel`),
      onClick: handleVerifyClick,
    },
  }
}
